<template>
  <v-col class="d-flex justify-end align-center pa-1">
    <router-link
      v-if="linkToPage"
      :to="{ name: linkToPage, params: { id } }"
      target="_blank"
    >
      <v-btn v-if="id" icon class="modal__btn" @click="close">
        <v-icon color="black darken-2">
          edit
        </v-icon>
      </v-btn>
    </router-link>
    <v-btn icon class="modal__btn" @click="close">
      <v-icon color="black darken-2">
        close
      </v-icon>
    </v-btn>
  </v-col>
</template>

<script>
export default {
  props: ["componentName", "id"],
  data() {
    return {
      isModalClose: false,
    };
  },
  computed: {
    linkToPage() {
      if (this.componentName) {
        return (
          this.componentName.charAt(0).toLowerCase() +
          this.componentName.slice(1)
        );
      }
      return "";
    },
  },
  methods: {
    close() {
      this.isModalClose = !this.isModalClose;
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}

.modal__btn {
  pointer-events: auto;
}
</style>
